<div class="input-group">
    <input class="form-control" [(ngModel)]="data" [type]="isVisible ? 'text' : 'password'" />
    <div class="input-group-append">
        <button class="btn btn-primary" type="button" (click)="toggleVisibility()">
            @if (isVisible) {
                <i class="far fa-eye-slash text-white"></i>
                <span>{{ 'Hide' | localize }}</span>
            } @else {
                <i class="far fa-eye text-white"></i>
                <span>{{ 'Show' | localize }}</span>
            }
        </button>
    </div>
</div>
